import React from 'react';
import buildsEnhancedMarkdownOverrides from '@resources/js/helpers/buildsEnhancedMarkdownOverrides';
import EnhancedMarkdown from '@resources/js/components/EnhancedMarkdown/EnhancedMarkdown';

export type BuildsOpenerSectionViewModel = {
  title: string;
  description: string;
};

export default function BuildsOpenerSection({
  title,
  description,
}: BuildsOpenerSectionViewModel): JSX.Element {
  return (
    <div className='builds-opener-section'>
      <EnhancedMarkdown
        markdown={`
# ${title}

${description}
`}
        overrides={buildsEnhancedMarkdownOverrides}
      />
    </div>
  );
}
